import React from 'react'
import { Loader } from '@athlinks/component-library'

export const Loading = () => (
  <div className='loader'>
    <Loader color='dark-blue' />
  </div>
)
